export default "__VITE_ASSET__CCl0u9Sa__"